import type { Adventure } from '../../types'

// Shape Detective - Age 3 - 2D shape recognition
export const tillyDetectiveCorrect = [
  "Perfect! You found the shape!",
  "That's right! Shape detective!",
  "Excellent! You know your shapes!",
  "Wonderful! You spotted it!",
  "Yes! That's the right shape!",
  "Brilliant shape recognition!",
  "Super job! You found it!",
  "You got it! Shape master!",
  "Fantastic detecting!",
  "Amazing! You are a shape expert!"
]

export const tillyDetectiveWrong = [
  "Look at the sides! How many does it have?",
  "Almost! Count the corners!",
  "Good try! Look at the shape carefully!",
  "So close! Circles are round!",
  "Count the sides of the shape!",
  "You are learning! Look for corners!",
  "Try again! Find the right shape!",
  "Think about the shape's sides!",
  "Let's look at the shapes together!",
  "Keep trying! You will spot it!"
]

export const shapeDetectiveAdventure: Adventure = {
  id: 'shape-detective',
  title: 'Shape Detective',
  theme: 'shapes',
  targetAge: '3',
  difficulty: 'easy',
  estimatedDuration: 8,
  segments: {
    intro: {
      id: 'intro',
      tillyLine: "Hello detective! I am Tilly! We are going on a shape hunt! Can you spot circles, squares, and triangles?",
      duration: 4
    },
    story1: {
      id: 'story-1',
      tillyLine: "A circle is round like a ball! A square has 4 equal sides! A triangle has 3 sides! Let's find them!",
      duration: 5
    },
    choice1: [
      {
        id: 'circle',
        label: 'Find circles!',
        tillyLine: "Round and round!",
        nextState: 'quiz-1'
      },
      {
        id: 'square',
        label: 'Find squares!',
        tillyLine: "Four equal sides!",
        nextState: 'story-2'
      }
    ],
    quiz1: {
      id: 'quiz-1',
      type: 'tap-correct',
      question: 'Which one is a CIRCLE?',
      tillyPrompt: '🔴 🟥 🔺 Round with no corners!',
      options: [
        { id: 'circle', label: '🔴 Red Circle', isCorrect: true },
        { id: 'square', label: '🟥 Red Square', isCorrect: false },
        { id: 'triangle', label: '🔺 Red Triangle', isCorrect: false }
      ]
    } as any,
    story2: {
      id: 'story-2',
      tillyLine: "Great! Now let's find squares and triangles! Remember: squares have 4 sides, triangles have 3!",
      duration: 4
    },
    choice2: [
      {
        id: 'triangle',
        label: 'Find triangles!',
        tillyLine: "Three sides only!",
        nextState: 'quiz-2'
      },
      {
        id: 'shapes',
        label: 'All shapes!',
        tillyLine: "Every shape!",
        nextState: 'quiz-2'
      }
    ],
    quiz2: {
      id: 'quiz-2',
      type: 'tap-correct',
      question: 'Which one is a TRIANGLE?',
      tillyPrompt: '🟡 🔺 🟩 Three corners, three sides!',
      options: [
        { id: 'circle', label: '🟡 Yellow Circle', isCorrect: false },
        { id: 'triangle', label: '🔺 Yellow Triangle', isCorrect: true },
        { id: 'square', label: '🟩 Green Square', isCorrect: false }
      ]
    } as any,
    challenge: {
      intro: {
        id: 'challenge-intro',
        tillyLine: "Shape detective! Challenge Round: Find rectangles, stars, and more!",
        duration: 4
      },
      quizzes: [
        {
          id: 'challenge-1',
          type: 'tap-correct',
          question: 'Which is a SQUARE?',
          tillyPrompt: '🟦 🔶 🟪 Four equal sides!',
          options: [
            { id: 'square', label: '🟦 Blue Square', isCorrect: true },
            { id: 'diamond', label: '🔶 Diamond', isCorrect: false },
            { id: 'circle', label: '🟪 Purple Circle', isCorrect: false }
          ]
        } as any,
        {
          id: 'challenge-2',
          type: 'tap-correct',
          question: 'Find the RECTANGLE!',
          tillyPrompt: '⬛ 📘 ⭐ Like a long square!',
          options: [
            { id: 'square', label: '⬛ Black Square', isCorrect: false },
            { id: 'rectangle', label: '📘 Blue Book', isCorrect: true },
            { id: 'star', label: '⭐ Star', isCorrect: false }
          ]
        } as any,
        {
          id: 'challenge-3',
          type: 'tap-correct',
          question: 'Find the STAR!',
          tillyPrompt: '🔴 🟦 ⭐ Pointy and bright!',
          options: [
            { id: 'circle', label: '🔴 Circle', isCorrect: false },
            { id: 'square', label: '🟦 Square', isCorrect: false },
            { id: 'star', label: '⭐ Star', isCorrect: true }
          ]
        } as any
      ]
    },
    reward: {
      tillyLine: "Incredible! You found all the shapes! You are an official Shape Detective!",
      badgeName: 'Shape Detective',
      badgeIcon: '🔍',
      nextPreview: 'Next time, we will do subtraction under the sea!'
    }
  }
}
